import { Component, OnInit, Input, Injector, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToolSetService, PartService, PressService } from '../../../../phf.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { PartDetailService } from '../part-detail.service';
import { FormDialogTemplate } from '../../../../../../shared/form-dialog/form-dialog.template';
import { PartListService } from '../../part-list.service';
import { S3Service } from '../../../../../../shared/services/s3.service';
import { FilterableService } from '../../../../../../../../src/app/components/mesc/filterable-service';
import { ToolsetEditWindowComponent } from './toolset-edit-window/toolset-edit-window.component';
import { CgpConfirmationDialogService } from '../../../../../../../../src/app/shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'part-detail-header',
  templateUrl: './part-detail-header.component.html',
  styleUrls: ['../part-detail.component.scss', './part-detail-header.component.scss']
})
export class PartDetailHeaderComponent implements OnInit {
  @ViewChild(ToolsetEditWindowComponent, { static: true }) toolsetEditWindow: ToolsetEditWindowComponent;
  
  part: any
  editForm: FormGroup;
  isEditing: boolean;
  isLoading = false;
  formDialog: FormDialogTemplate;
  toolsetPartIds: any[] = [];
  partsSPM: any[] = [];
  showToolsetWindow = false;
  pressList: any[] = [];
  toolSetCodeList: any[] = [];
  toolSetCode: any;
  toolSet: any;
  imageUrl: any;
  clickImg: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  plantPresses: any;
  
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  private readonly formBuilder: FormBuilder;
  private readonly messageService: PartDetailService;
  private readonly s3Service: S3Service;
  private readonly partListService: PartListService;
  private readonly partService: PartService;
  private readonly toolsetService: ToolSetService;
  private readonly pressService: PressService;
  private programService: FilterableService;
  private plantService: FilterableService;
  phfToolsetService: any;
  save: any;
  
  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.part = dataItem;
    }
  }
  
  @Output()
  refresh: EventEmitter<any> = new EventEmitter();
  
  constructor(
    private readonly injector: Injector,
    private readonly cgpConfirmationDialog: CgpConfirmationDialogService,
    ) {
    this.formBuilder = injector.get(FormBuilder);
    this.messageService = injector.get(PartDetailService);
    this.s3Service = injector.get(S3Service);
    this.partListService = injector.get(PartListService);
    this.partService = injector.get(PartService);
    this.pressService = this.injector.get(PressService);
    this.toolsetService = injector.get(ToolSetService);
    
    this.messageService.getMessage()
      .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(message => {
      this.isEditing = message.editing;
    });
  }
  
  ngOnInit() {
    this.editForm = this.formBuilder.group(PartDetailHeaderEditForm);
    this.messageService.partDetailHeaderDataObject = this.editForm;
    this.plantService = this.partListService.lookupData.PlantViewDto;
    this.programService = this.partListService.lookupData.ProgramViewDto;
    this.pressService.next([]);
    this.refreshInfo();
  }
  
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  
  refreshInfo() {
    this.editForm.reset(this.part);
    this.messageService.pressId = this.editForm.get('PressId').value;
    
    if (this.editForm.get('ProgramId').value) { this.handleProgramChange(this.editForm.get('ProgramId').value); }
    if (this.editForm.get('PlantId').value) { this.handlePlantChange(this.editForm.get('PlantId').value); }
    if (this.editForm.get('PressId').value) { this.handlePressChange(this.editForm.get('PressId').value); }
    
    this.getToolSetParts(null);
    
    if (this.getUrl()) {
      this.editForm.get('Attachment').setValue(this.getUrl());
    }
  }
  
  openToolsetWindow() {
    if(!this.editForm.get('Id').value){
      this.cgpConfirmationDialog.showConfirmationDialog({
        title: 'Save Confirmation',
        message: `In order to include this part: ${this.editForm.get('Code').value} in toolset editing, the part must be saved first. Do you wish to continue?`,
        alert: 'danger',
        onYesClick: () => {
          this.cgpConfirmationDialog.closeConfirmationDialog();
          this.messageService.save(true);
          this.messageService.pressId = this.editForm.get('PressId').value;
          this.messageService.isSaving.subscribe(x => {
            if(x === false){
              this.toolsetEditWindow.refreshInfo();
              this.showToolsetWindow = true;
            } 
          });
        },
        onNoClick: () => {
              this.cgpConfirmationDialog.closeConfirmationDialog();
        }
      });
    }
    else{
      this.toolsetEditWindow.refreshInfo();
      this.showToolsetWindow = true;
    }
  }
  handleToolSetCodeChange(arg0: string): any {
    throw new Error("Method not implemented.");
  }
  closeToolsetWindow() {
    this.showToolsetWindow = false;
  }
  
  updateToolsetData(dataItem: any) {
    this.showToolsetWindow = false;
    this.getToolSetParts(dataItem.get('Code').value);
    this.refresh.emit();
  }
  
  // Get the parts associated to the currently selected toolset.
  getToolSetParts(toolSetCode: any) {
    this.isLoading = true;
    if (this.editForm.get('Id').value) {
      this.getToolSetList(toolSetCode)
      .then(() => {
        if (this.toolSet) {
          this.getToolSetDetail(this.toolSet)
          .then(() => {
            const _path = `/GetByPartIds${this.serailizeRequestArray(this.toolsetPartIds, 'ids')}`;
            this.partService.read(_path)
            .then(partResult => this.updatePartSpmData(partResult));
          });
        } else {
          this.isLoading = false;
          this.setToolSet(null, null, null, null);
        }
      });
    } else {
      this.isLoading = false;
    }
  }
  
  // Get the list of toolsets currently associated to the selected part.
  getToolSetList(toolSetCode: any): Promise<any> {
    return this.toolsetService.read('/ToolSets/Part/' + this.editForm.get('Id').value)
    .then(toolSetsResult => {
      if (toolSetsResult) {
        this.toolSetCodeList = [];
        if (toolSetsResult.length) {
          toolSetsResult.map(x => this.toolSetCodeList.push(x.Code))
          if(toolSetsResult.find(x => x.Code === toolSetCode)) this.toolSetCode = toolSetCode;
          else this.toolSetCode = toolSetsResult[0].Code;
          this.toolSet = toolSetsResult.find(x => x.Code === this.toolSetCode);
        } else {
          this.toolSetCode = null;
          this.toolSet = null;
        }
      }
    });
  }
  
  // Assign all of the parts in the toolset, phf part calculation viewing format (red, yellow, green).
  getToolSetDetail(toolSet: any): Promise<any> {
    if (toolSet.ToolSetId) {
      return this.toolsetService.read('/ToolSet/' + toolSet.ToolSetId)
      .then(toolSetResult => {
        this.setToolSet(toolSetResult.ToolSetId, toolSetResult.Code, toolSetResult.Parentpart, toolSetResult.Parts);
        toolSetResult.Parts.map((item) => {
          const temp = {};
          temp['Code'] = item.Code;
          temp['PartId'] = item.Id;
          temp['OverallSPMValue'] = new BehaviorSubject<any>(null);
          temp['TargetSPMValue'] = new BehaviorSubject<any>(null);
          temp['SPMFlag'] = null;
          this.partsSPM.push(temp);
        });
        toolSetResult.Parts.map(item => this.toolsetPartIds.push(item.Id));
      });
    }
    return null;
  }
  
  // Update each part in the toolset with the SPM data for the phf part calcuation viewing format
  private updatePartSpmData(partResult: any[]) {
    if (partResult) {
      partResult.forEach(item => {
        this.partsSPM.forEach(obj => {
          if (obj.Code === item.Code) {
            obj.OverallSPMValue.next(item.Throughput.OverallSPM);
            obj.TargetSPMValue.next(item.TargetSPM);
            obj.SPMFlag = item.Throughput.SPMFlag;
          }
          this.isLoading = false;
        });
      });
    } else {
      this.isLoading = false;
    }
  }
  
  // Set the current toolset details to the form group for the selected toolset,
  setToolSet(ToolSetId: any, Code: any, Parentpart: any, Parts: any) {
    this.editForm.get('ToolSetId').setValue(ToolSetId);
    this.editForm.get('ToolSetCode').setValue(Code);
    this.editForm.get('Parentpart').setValue(Parentpart);
    this.editForm.get('Parts').setValue(Parts);
    this.partsSPM = [];
  }
  
  handleCalculateToolSetPart = (dataItem) => {
    this.partListService.selectedPart.next(dataItem);
  }
  
  serailizeRequestArray(data: any[], paramName: string): string {
    let requestStr = `?${paramName}=`;
    requestStr += data[0];
    for (let i = 1; i < data.length; i++) {
      requestStr += `&${paramName}=`;
      requestStr += data[i];
    }
    
    return requestStr;
  }
  
  getColorClass = (flag: string, part): string => {
    return flag === 'G' ? `cgp-success ${this.isParentPart(part.Code)}` :
    flag === 'Y' ? `secondary-yellow ${this.isParentPart(part.Code)}` : `cgp-red ${this.isParentPart(part.Code)}`;
  }
  
  isParentPart(code): string {
    if (code === this.editForm.get('Parentpart').value.Code) {
      return 'partlead';
    } else {
      return '';
    }
  }
  
  getUrl(): string {
    let attachmentUrl: string = null;
    if (this.part.AttachmentFileInfo) {
      const filePath = 'PHF/PartPictures' + this.part.AttachmentFileName;
      attachmentUrl = this.s3Service.getS3Path(filePath);
      this.editForm.get('Attachment').setValue(attachmentUrl);
    }
    return attachmentUrl;
  }
  
  handleProgramChange = (dataItem) => {
    const program = this.programService.value.find(x => x.Id === dataItem);
    this.editForm.get('ProgramName').setValue(program ? program.Code : '');
  }
  
  handlePlantChange = (dataItem) => {
    const plant = this.plantService.value.find(x => x.Id === dataItem);
    this.editForm.get('PlantId').setValue(plant ? plant.Id : '');
    this.editForm.get('PlantName').setValue(plant ? plant.Name : '');
    
    if (dataItem == null) { //no Plant selected, no Press selected
      this.editForm.get('PressDescription').setValue(null);
      this.editForm.get('PressId').setValue(null);
      this.pressService.next(null);
      this.messageService.pressDataObject.reset(null);
    }
    else { //Plant selected -> populate Press dropdown
      this.pressService.read('/plant/' + plant.Id)
      .then(x => {
        x.map(p => {
          p.Description = `${p.Number}, Type: ${p.Type}, Class: ${p.Class}`;
          return p;
        });
        x.sort((a,b) => a.Description.localeCompare(b.Description));
        return x;
      });
    }
  }
  
  handlePressChange = (dataItem) => {
    const plantId = this.editForm.get('PlantId').value;
    let press;
    
    if (plantId) {
      this.pressService.read('/plant/' + plantId)
      .then(x => {
        x.map(p => {
          p.Description = `${p.Number}, Type: ${p.Type}, Class: ${p.Class}`;
          return p;
        });
        
        press = dataItem ? x.find(t => t.Id === dataItem) : null;
        if (press) {
          this.editForm.get('PressDescription').setValue(press.Description);
          this.editForm.get('PressId').setValue(press.Id);
          this.messageService.pressDataObject.reset(press);
          this.messageService.pressDataObject.get('PressId').setValue(press.Id);
        }
        x.sort((a,b) => a.Description.localeCompare(b.Description));
        return x;
      });
    }
  }
  
  isPressDisabled(): boolean {
    return !this.editForm.controls["PlantId"].valid;
  }

  isToolsetDisabled(): boolean {
    if(this.editForm.valid) return false;
    return true;
  }
  
  isImgOpen = () => {
    return this.clickImg.value;
  }
  
  openImg = () => {
    this.clickImg.next(true);
  }
  
  closeImg = () => {
    this.clickImg.next(false);
  }
}

const PartDetailHeaderEditForm = {
  // from part service
  Id: [],
  Code: ['', Validators.required],
  Number: ['', Validators.required],
  Name: ['', Validators.required],
  ImageTeamcenterURL: [],
  ProgramId: [],
  ProgramName: ['', Validators.required],
  PressId: ['', Validators.required],
  Attachment: [],
  AttachmentFileInfo: [],
  
  // from plant service
  PlantId: ['', Validators.required],
  PlantName: [],
  
  // from press service
  PressDescription: [],
  
  // from toolset service
  ToolSetId: [],
  ToolSetCode: [],
  Parentpart: [],
  Parts: [],
}
